import React from 'react'
import './Home.css';
import i from './img/2.png'
import im from './img/3.png'
import imm from './img/large-exclamation-mark.png'
import immm from './img/license.png'
import { Container } from 'react-bootstrap';
import Fade from 'react-reveal/Fade';




export const Home = () => (

  <Container  >



     
  <div style={styles.mainContainer}>
      <Fade bottom>
        {/* כותרות עליונות - מראה מודרני מרווח */}
        <div style={styles.heroSection}>
          <h1 style={styles.heroTitle}>   
         
            <span>מקימים עסק</span><img src={im} alt="2" style={styles.mainIcon} />
          </h1>
          <h1 style={styles.heroTitle}>
            <div style={styles.iconGroup}>
          
            </div>
            <span>מחדשים רישיון</span>     <img src={im} alt="2" style={styles.mainIcon} />
               <img src={immm} alt="2" style={styles.mainIcon} />
          </h1>
          <h1 style={{...styles.heroTitle, color: '#2ecc71'}}>

            <span>הגעתם למקום הנכון</span>            <img src={imm} alt="2" style={styles.mainIcon} />
          </h1>
        </div>

        {/* רשימת שירותים מעוצבת ככרטיסים */}
        <div style={styles.servicesGrid}>
          {[
            "תכנון העסק",
            "התאמת העסק והדרכה בהתאם לצו רישוי עסקים",
            "אישור הרשויות המקומיות",
            "אישור משרד הבריאות",
            "היתר כסאות שולחנות חיצוני וסגירות חורף"
          ].map((text, index) => (
            <div key={index} style={styles.serviceCard}>
              <img className="im" src={i} alt="check" style={styles.checkIcon} />
              <h3 style={styles.serviceText}>{text}</h3>
            </div>
          ))}
        </div>
      </Fade>
    </div>



    </Container>
 

)
const styles = {
  mainContainer: {
    direction: 'rtl',
    textAlign: 'center',
    padding: '60px 20px',
    backgroundColor: '#ffffff',
    fontFamily: 'Segoe UI, Tahoma, Geneva, sans-serif',
  },
  heroSection: {
    marginBottom: '50px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '20px'
  },
  heroTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '15px',
    fontSize: '2.5rem',
    fontWeight: '800',
    color: '#2c3e50',
    margin: 0,
    textShadow: '0 2px 4px rgba(0,0,0,0.05)'
  },
  iconGroup: {
    display: 'flex',
    gap: '5px'
  },
  mainIcon: {
    height: '50px',
    width: 'auto',
    objectFit: 'contain'
  },
  servicesGrid: {
    maxWidth: '800px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px'
  },
  serviceCard: {
    display: 'flex',
    alignItems: 'center',
    padding: '20px 30px',
    backgroundColor: '#f8f9fa',
    borderRadius: '15px',
    transition: 'transform 0.3s ease',
    border: '1px solid #edf2f7',
    boxShadow: '0 4px 6px rgba(0,0,0,0.02)',
    // דואג שהאייקון יהיה בימין
    flexDirection: 'row', 
    gap: '20px'
  },
  serviceText: {
    margin: 0,
    fontSize: '1.3rem',
    color: '#4a5568',
    fontWeight: '600',
    textAlign: 'right'
  },
  checkIcon: {
    width: '30px',
    height: '30px',
    flexShrink: 0
  }
};


    ////<a href="https://www.instagram.com/hai_vaizman/"> @hai_vaizman instagram אתר אינטרנט נבנה על ידי  </a>